module.exports = __webpack_public_path__ + "media/images/emoticons/xmas-75fc5f5a5de94a269b997e089a57c398.gif";